import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {Compbaser} from "../compbaser";
import {StoreSelectorsService} from "../../services";
import * as _ from 'lodash';

declare var jQuery: any;

@Component({
    selector: 'app-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent extends Compbaser implements OnInit {
    context = null;
    errorMargin = 5;
    m_divCaptcha;
    m_canvasCaptcha;


    @ViewChild('divCaptcha', {static: false}) set divCaptcha(element) {
        if (!element) return;
        this.m_divCaptcha = element;
        this.ngZone.runOutsideAngular(() => {
            const randomX = _.random(0.1, 0.9);
            const captchaX = 50 + randomX * 200;
            console.log(`creating on server side and answer should be ${captchaX} `);
            this.show(randomX, _.random(0.1, 0.9));
        });
    }


    constructor(private ngZone: NgZone) {
        super();
    }

    ngOnInit() {
    }

    show(xPercent, yPercent) {
        const container = this.m_divCaptcha.nativeElement;
        // const canvas = this.m_canvasCaptcha.nativeElement;
        let captchaX = 50 + xPercent * 200;
        let captchaY = 5 + yPercent * 250;
        // pick a random position if no position was specified
        if (xPercent === undefined) {
            captchaX = 50 + Math.random() * 300;
        }
        if (yPercent === undefined) {
            captchaY = 5 + Math.random() * 250;
        }
        // create the container
        // const container = jQuery('.captchaCanvas');
        // this.container = document.createElement("div");
        // container.style.cssText = "box-sizing:border-box;position:absolute;top:100px;left:50%;width:420px;margin-left:-200px;background-color:#eeeeee;border:1px solid #dddddd;box-shadow:0px 0px 10px #555555;text-align:center;z-index:999;";
        const canvas = document.createElement("canvas");
        canvas.width = 300;
        canvas.height = 300;
        canvas.style.cssText = "touch-action:none;box-sizing:border-box;width:300px;height:300px;margin:10px 0px;";
        container.appendChild(canvas);
        this.context = canvas.getContext("2d");
        this.context.lineWidth = 3;
        // load and draw the image
        const image = new Image();
        image.src = "assets//images/light-drawer-background.jpg";
        image.onload = () => {
            this.context.drawImage(image, 0, 0, 300, 300);
            this.context.fillStyle = "#ffffff55";
            this.context.fillRect(captchaX, captchaY, 40, 40);
            this.context.strokeStyle = "#434343";
            this.context.beginPath();
            this.context.rect(captchaX, captchaY, 40, 40);
            this.context.stroke();
            // target
            this.context.drawImage(image, captchaX, captchaY, 40, 40, 0, captchaY, 40, 40);
            this.context.strokeStyle = "#ff0000";
            this.context.beginPath();
            this.context.rect(0, captchaY, 40, 40);
            this.context.stroke();
        };
        // slider background
        const sliderBackground = document.createElement("div");
        sliderBackground.style.cssText = "box-sizing:border-box;position:relative;display:inline-block;width:300px;height:40px;margin-bottom:8px;background-color:#262626;border:1px solid #dddddd;";
        const slider = document.createElement("div");
        slider.style.cssText = "box-sizing:border-box;position:absolute;left:0px;width:38px;height:38px;background-color:#cccccc;border:1px solid #bbbbbb;font-size:24px;color:#555555;text-align:center;line-height:38px;cursor:grab;user-select:none;";
        slider.textContent = "➔";
        let b_sliderIsDragging = false;
        let sliderDragStartX = 0;
        let sliderDragStartLeft = 0;
        let sliderLeft = 0;
        jQuery(slider).bind('touchstart mousedown', (e) => {
            b_sliderIsDragging = true;
            const touchLocation = e?.targetTouches?.[0];
            if (touchLocation) {
                e.clientX = touchLocation.pageX;
            }
            sliderDragStartX = e.clientX;
            sliderDragStartLeft = parseInt(slider.style.left.substring(0, slider.style.left.indexOf("px")));
        });
        jQuery(container).bind('touchmove mousemove', (e) => {
            if (b_sliderIsDragging) {
                const touchLocation = e?.targetTouches?.[0];
                if (touchLocation) {
                    e.clientX = touchLocation.pageX;
                }
                let dx = e.clientX - sliderDragStartX;
                e.targetTouches;
                sliderLeft = sliderDragStartLeft + dx;
                if (sliderLeft < 0) sliderLeft = 0;
                if (sliderLeft > 260) sliderLeft = 260;
                slider.style.left = sliderLeft + "px";
                // redraw canvas
                this.context.clearRect(0, 0, 300, 300);
                this.context.drawImage(image, 0, 0, 300, 300);
                this.context.fillStyle = "#ffffff55";
                this.context.fillRect(captchaX, captchaY, 40, 40);
                this.context.strokeStyle = "#000000";
                this.context.beginPath();
                this.context.rect(captchaX, captchaY, 40, 40);
                this.context.stroke();
                // target
                this.context.drawImage(image, captchaX, captchaY, 40, 40, sliderLeft, captchaY, 40, 40);
                if (Math.abs(sliderLeft - captchaX) < this.errorMargin) {
                    this.context.strokeStyle = "#00ff00"; // enable to show green on pass
                    // this.context.strokeStyle = "#ff0000";
                } else {
                    this.context.strokeStyle = "#ff0000";
                }
                this.context.beginPath();
                this.context.rect(sliderLeft, captchaY, 40, 40);
                this.context.stroke();
            }
        });
        jQuery(container).bind('mouseup touchend', (e) => {
            b_sliderIsDragging = false;
            if (Math.abs(sliderLeft - captchaX) < this.errorMargin) {
                console.log('pass and answer on client side is +/- 5 points = ' + sliderLeft);
            } else {
                console.log('fail');
            }
        });
        sliderBackground.appendChild(slider);
        container.appendChild(sliderBackground);
    }
}

